import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import { aboutInfo } from '@/mocks/movies';

export default function About() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: aboutInfo.faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '关于我们 - 大师兄影视',
            description: '大师兄影视品牌介绍，汇聚电视剧全集、电影大全、热门综艺、经典影片，高清免费在线观看。了解我们的品牌故事、核心优势和联系方式。',
            url: 'https://www.dashixiong.tv/about',
          }),
        }}
      />

      <Navbar />

      <main className="pt-20 pb-12">
        <div className="w-full px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          {/* Hero */}
          <section className="mt-8 text-center max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-bold text-foreground-100 font-heading">
              关于 <span className="text-primary-400">{aboutInfo.brandName}</span>
            </h1>
            <p className="text-base text-foreground-400 mt-4 leading-relaxed">
              {aboutInfo.introduction}
            </p>
            <p className="text-sm text-foreground-500 mt-3">
              {aboutInfo.mission}
            </p>
          </section>

          {/* Stats */}
          <section className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {aboutInfo.stats.map((stat) => (
              <div
                key={stat.label}
                className="bg-background-100 border border-background-200 rounded-xl p-5 md:p-6 text-center"
              >
                <p className="text-2xl md:text-3xl font-bold text-primary-400 font-heading">{stat.value}</p>
                <p className="text-sm text-foreground-500 mt-1.5">{stat.label}</p>
              </div>
            ))}
          </section>

          {/* Features */}
          <section className="mt-14">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-100 font-heading text-center mb-8">
              我们的优势
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {aboutInfo.features.map((feature) => (
                <div
                  key={feature.title}
                  className="bg-background-100 border border-background-200 rounded-xl p-6 hover:border-primary-500/20 transition-colors"
                >
                  <div className="w-12 h-12 flex items-center justify-center bg-primary-500/10 rounded-xl mb-4">
                    <i className={`${feature.icon} text-xl text-primary-400`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-200 font-heading">{feature.title}</h3>
                  <p className="text-sm text-foreground-500 mt-2 leading-relaxed">{feature.description}</p>
                </div>
              ))}
            </div>
          </section>

          {/* FAQ */}
          <section className="mt-14">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-100 font-heading text-center mb-8">
              常见问题
            </h2>
            <div className="max-w-3xl mx-auto flex flex-col gap-3">
              {aboutInfo.faqs.map((faq, index) => (
                <details
                  key={index}
                  className="group bg-background-100 border border-background-200 rounded-xl overflow-hidden"
                >
                  <summary className="px-5 py-4 cursor-pointer flex items-center justify-between gap-3 text-sm font-medium text-foreground-200 hover:text-foreground-100 transition-colors">
                    <span>{faq.question}</span>
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-500 group-open:rotate-180 transition-transform">
                      <i className="ri-arrow-down-s-line text-lg"></i>
                    </div>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-400 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </section>

          {/* Contact Form */}
          <section id="contact" className="mt-14">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-100 font-heading text-center mb-2">
              联系我们
            </h2>
            <p className="text-sm text-foreground-500 text-center mb-8">
              如有任何问题或建议，欢迎与我们联系
            </p>

            <div className="max-w-2xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Contact Info */}
              <div className="flex flex-col gap-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-primary-500/10 rounded-lg flex-shrink-0">
                    <i className="ri-mail-line text-lg text-primary-400"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-200">邮箱</p>
                    <p className="text-sm text-foreground-500">{aboutInfo.contact.email}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-primary-500/10 rounded-lg flex-shrink-0">
                    <i className="ri-phone-line text-lg text-primary-400"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-200">电话</p>
                    <p className="text-sm text-foreground-500">{aboutInfo.contact.phone}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-primary-500/10 rounded-lg flex-shrink-0">
                    <i className="ri-map-pin-line text-lg text-primary-400"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-200">地址</p>
                    <p className="text-sm text-foreground-500">{aboutInfo.contact.address}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-primary-500/10 rounded-lg flex-shrink-0">
                    <i className="ri-wechat-line text-lg text-primary-400"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-200">微信</p>
                    <p className="text-sm text-foreground-500">{aboutInfo.contact.wechat}</p>
                  </div>
                </div>
              </div>

              {/* Form */}
              <div>
                <form
                  id="contact-form"
                  data-readdy-form
                  className="flex flex-col gap-3"
                  onSubmit={async (e) => {
                    e.preventDefault();
                    const form = e.currentTarget;
                    const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
                    if (honeypot) {
                      const msg = document.getElementById('contact-form-msg');
                      if (msg) { msg.textContent = '提交成功，我们会尽快回复！'; msg.className = 'text-sm text-green-400 mt-2'; }
                      form.reset();
                      return;
                    }
                    const formData = new FormData(form);
                    try {
                      const res = await fetch('https://readdy.ai/api/form/d9n13vobdkpk99j7gf8g', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                      });
                      const responseText = await res.text();
                      const msg = document.getElementById('contact-form-msg');
                      if (msg) {
                        if (res.ok) {
                          try {
                            const parsed = JSON.parse(responseText);
                            if (parsed?.code === 'OK') {
                              msg.textContent = '提交成功，我们会尽快回复！';
                              msg.className = 'text-sm text-green-400 mt-2';
                              form.reset();
                            } else {
                              msg.textContent = parsed?.meta?.message || parsed?.message || '提交失败，请重试';
                              msg.className = 'text-sm text-red-400 mt-2';
                            }
                          } catch {
                            msg.textContent = '提交成功，我们会尽快回复！';
                            msg.className = 'text-sm text-green-400 mt-2';
                            form.reset();
                          }
                        } else {
                          msg.textContent = '提交失败，请稍后重试';
                          msg.className = 'text-sm text-red-400 mt-2';
                        }
                      }
                    } catch {
                      const msg = document.getElementById('contact-form-msg');
                      if (msg) {
                        msg.textContent = '网络错误，请稍后重试';
                        msg.className = 'text-sm text-red-400 mt-2';
                      }
                    }
                  }}
                >
                  <input
                    type="text"
                    name="name"
                    placeholder="您的姓名"
                    required
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200 rounded-lg text-foreground-200 placeholder-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="您的邮箱"
                    required
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200 rounded-lg text-foreground-200 placeholder-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors"
                  />
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="absolute opacity-0 pointer-events-none"
                    style={{ position: 'absolute', left: '-9999px', top: '-9999px' }}
                  />
                  <textarea
                    name="message"
                    placeholder="请输入您的留言..."
                    rows={4}
                    maxLength={500}
                    required
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200 rounded-lg text-foreground-200 placeholder-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors resize-none"
                  ></textarea>
                  <button
                    type="submit"
                    className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer"
                  >
                    发送消息
                  </button>
                  <p id="contact-form-msg" className="text-sm mt-1"></p>
                </form>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </>
  );
}